import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { fn } from '@ember/helper';
import { t } from 'ember-intl';
import { faXmark } from '../icons/solid';
import Icon from './icon.gjs';

export default class ChipsInput extends Component {
  @tracked inputValue = '';

  @action
  handleInput(event) {
    this.inputValue = event.target.value;
  }

  @action
  handleKeydown(event) {
    const value = this.inputValue.trim();

    if (
      event.key === 'Backspace' &&
      value === '' &&
      this.args.items.length > 0
    ) {
      event.preventDefault();
      this.args.removeItem(this.args.items.length - 1);
      return;
    }

    if (event.key === 'Enter' && value !== '') {
      event.preventDefault();
      this.args.addItem(value);
      this.inputValue = '';
      return;
    }
  }

  <template>
    <div class="input flex flex-wrap h-auto p-3" ...attributes>
      {{#each @items as |item index|}}
        <span class="badge badge-primary flex items-center p-3 pr-0">
          {{item}}
          <button
            type="button"
            class="btn btn-xs btn-ghost btn-primary btn-square"
            {{on "click" (fn @removeItem index)}}
          >
            <Icon @icon={{faXmark}} @size="sm" />
          </button>
        </span>
      {{/each}}

      <input
        type="text"
        class="h-auto w-auto min-w-[180px] flex-grow"
        placeholder={{t "chips-input.placeholder"}}
        value={{this.inputValue}}
        {{on "input" this.handleInput}}
        {{on "keydown" this.handleKeydown}}
      />
    </div>
  </template>
}
